import baseApi from "./api";
import baseURLs from "../configs/baseURLs";


class PersonService {
    constructor(){
        this.api = baseApi(baseURLs.API_PERSON)
    }

    async getAll(person, signal) {
        const result = await this.api.post('carregarPessoa', person, {signal});
        return result.data
    }

    async getOne(person, signal)  {
        const result = await this.api.post('carregarPessoa', person, {signal});
        return result.data
    }

    async getCNPJ(person)  {
        const result = await this.api.post('consultarCNPJ', person);
        return result.data
    }

    async save(person) {
        const result = await this.api.post('salvarPessoa', person);
        return result.data;
    }

    async cancel(person) {
        const result = await this.api.post('salvarPessoa', person);
        return result.data;
    }

    async getAllListAddress(person) {
        const result = await this.api.post('listarEnderecoEntrega', person);
        return result.data;
    }

    async saveAddress(person) {
        const result = await this.api.post('inserirEnderecoEntrega', person);
        return result.data;
    }

    async updateStandardAddress(person) {
        const result = await this.api.post('alterarEnderecoEntrega', person);
        return result.data;
    }

    async cancelAddress(person) {
        const result = await this.api.post('excluirEnderecoEntrega', person);
        return result.data;
    }


    
}

export default PersonService